import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Last resort: the shell-level boundary inside AppLayout keeps the nav standing for a panel
        crash; this one catches anything above or outside it (a crash in the shell itself, or a route
        that doesn't use AppLayout) so the window still shows a fallback rather than going blank. */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
